import APIClient from '../factories/APIClient'
import generateDeviceId from '../../generateDeviceId'
import constructRequestData from '../../constructRequestData'

const client = new APIClient({
  baseURL: process.env.REACT_APP_IDENTITY_API_BASE_URL,
})

// to update
export const postRequestOtp = ({ accessToken, toMobile = false }) => {
  return client({
    method: 'post',
    url: '/delete-account/request-otp',
    data: constructRequestData({
      toMobile,
    }),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })
}

export const postVerifyOtp = ({ accessToken, requestId, code }) => {
  return client({
    method: 'post',
    url: '/delete-account/verify-otp',
    data: constructRequestData({
      requestId,
      code,
    }),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })
}
